import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `Date` scalar type represents a date. The Date appears in a JSON
	 * response as an ISO8601 formatted string, without a time component.
	 */
	Date: { input: string; output: string };
	/**
	 * The `DateTime` scalar type represents a date and time in the UTC
	 * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
	 * string, including UTC timezone ("Z"). The parsed date and time string will
	 * be converted to UTC if there is an offset.
	 */
	DateTime: { input: string; output: string };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values parsed by the `Decimal` library. The Decimal appears in a JSON
	 * response as a string to preserve precision.
	 */
	Decimal: { input: string; output: string };
	/**
	 * The `Money` scalar type represents a monetary value with a currency. The value
	 * is represented as a string in the format `"100.00 MXN"` or `"MXN 100.00"`.
	 */
	Money: { input: string; output: string };
	/**
	 * The `UUID7` scalar type represents UUID7 compliant string data, represented as UTF-8
	 * character sequences.
	 */
	UUID7: { input: string; output: string };
	/** Represents an uploaded file. */
	Upload: { input: File; output: File };
};

/** The action failed due to an unexpected reason. */
export type ActionFailed = {
	__typename?: 'ActionFailed';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

export type ActivityOrBusinessInformation = {
	__typename?: 'ActivityOrBusinessInformation';
	activityDetail?: Maybe<Scalars['String']['output']>;
	activityType?: Maybe<Scalars['String']['output']>;
	operatingTimeRange?: Maybe<OperatingTimeRanges>;
	startDate?: Maybe<Scalars['Date']['output']>;
};

export enum ApplicantPaymentExperienceI {
	NO_DATA = 'NO_DATA',
	NO_DELAY = 'NO_DELAY',
	ONE_MONTH = 'ONE_MONTH',
	SIX_MONTHS = 'SIX_MONTHS'
}

export enum ApplicantPaymentExperienceIi {
	NINETY_ONE_DAYS = 'NINETY_ONE_DAYS',
	ONE_DAY = 'ONE_DAY',
	SIXTY_ONE_DAYS = 'SIXTY_ONE_DAYS',
	THIRTY_ONE_DAYS = 'THIRTY_ONE_DAYS'
}

export type ApproveRequestByCreditCommitteeInput = {
	committeeDeliberation: Scalars['String']['input'];
	committeeRequestedChanges: Scalars['String']['input'];
	requestId: Scalars['UUID7']['input'];
};

export type ApproveRequestByCreditCommitteePayload = {
	__typename?: 'ApproveRequestByCreditCommitteePayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export enum CommitteeRuling {
	APPROVED_BY_COMMITTEE = 'APPROVED_BY_COMMITTEE',
	REJECTED_BY_COMMITTEE = 'REJECTED_BY_COMMITTEE'
}

export type ContractOpenfinVanCredit = {
	__typename?: 'ContractOpenfinVanCredit';
	creditContract?: Maybe<Scalars['String']['output']>;
	promissoryNote?: Maybe<Scalars['String']['output']>;
};

export type CreateVanCreditInput = {
	expectedDisbursementDate: Scalars['Date']['input'];
	requestId: Scalars['UUID7']['input'];
};

export type CreateVanCreditPayload = {
	__typename?: 'CreateVanCreditPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type CreditAccountDetails = {
	__typename?: 'CreditAccountDetails';
	amountRequested?: Maybe<Scalars['Money']['output']>;
	basisPoints?: Maybe<Scalars['Decimal']['output']>;
	daysPerPeriod?: Maybe<Scalars['Int']['output']>;
	firstPaymentDate?: Maybe<Scalars['Date']['output']>;
	gpsAmount?: Maybe<Scalars['Money']['output']>;
	insuranceAmount?: Maybe<Scalars['Money']['output']>;
	numberOfPeriods?: Maybe<Scalars['Int']['output']>;
	ordinaryInterestRate?: Maybe<Scalars['Decimal']['output']>;
	sameDayPayment?: Maybe<Scalars['Boolean']['output']>;
	tiieDate?: Maybe<Scalars['Date']['output']>;
	tiieValue?: Maybe<Scalars['Decimal']['output']>;
};

export type CreditBureauReport = {
	__typename?: 'CreditBureauReport';
	creditBureauScore?: Maybe<Scalars['Int']['output']>;
	firstCreditDate?: Maybe<Scalars['Date']['output']>;
	oldestDuePayment?: Maybe<OldestDuePayment>;
	reportDate?: Maybe<Scalars['Date']['output']>;
	totalActiveCreditBalance?: Maybe<Scalars['Money']['output']>;
	totalActiveNumberOfCredits?: Maybe<Scalars['Int']['output']>;
	totalCreditBalance?: Maybe<Scalars['Money']['output']>;
	totalNumberOfCredits?: Maybe<Scalars['Int']['output']>;
};

export type CreditDetails = {
	__typename?: 'CreditDetails';
	amountRequested?: Maybe<Scalars['Money']['output']>;
	downPaymentAmount?: Maybe<Scalars['Money']['output']>;
	downPaymentPercentage?: Maybe<Scalars['Decimal']['output']>;
	expectedAdditionalIncome?: Maybe<Scalars['Money']['output']>;
	term?: Maybe<Scalars['Int']['output']>;
	vehiclesRequested?: Maybe<Scalars['String']['output']>;
};

export type DatetimeRange = {
	from?: InputMaybe<Scalars['DateTime']['input']>;
	to?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DaysPerSimulationPeriod {
	BIWEEKLY = 'BIWEEKLY',
	MONTHLY = 'MONTHLY',
	WEEKLY = 'WEEKLY'
}

export type DocumentDownload = {
	__typename?: 'DocumentDownload';
	pdfBase64?: Maybe<Scalars['String']['output']>;
};

export enum DocumentFormat {
	CONTRACT = 'CONTRACT',
	PROMISSORY_NOTE = 'PROMISSORY_NOTE'
}

export type DownloadContractOpenfinVanCreditInput = {
	creditId: Scalars['UUID7']['input'];
};

export type DownloadContractOpenfinVanCreditPayload = {
	__typename?: 'DownloadContractOpenfinVanCreditPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	result?: Maybe<ContractOpenfinVanCredit>;
	successful: Scalars['Boolean']['output'];
};

export enum EconomicSolvencyI {
	LESS_FIVE_POINTS = 'LESS_FIVE_POINTS',
	LESS_FOUR_POINTS = 'LESS_FOUR_POINTS',
	LESS_THREE_POINTS = 'LESS_THREE_POINTS',
	MORE_FIVE_POINTS = 'MORE_FIVE_POINTS'
}

export enum EconomicSolvencyIi {
	BETWEEN_ONE_POINT = 'BETWEEN_ONE_POINT',
	EQUAL_TWO_POINTS = 'EQUAL_TWO_POINTS',
	LESS_ONE_POINT = 'LESS_ONE_POINT',
	MORE_TWO_POINTS = 'MORE_TWO_POINTS'
}

export type EvaluationMatrix = {
	__typename?: 'EvaluationMatrix';
	applicantPaymentExperienceI?: Maybe<ApplicantPaymentExperienceI>;
	applicantPaymentExperienceIi?: Maybe<ApplicantPaymentExperienceIi>;
	economicSolvencyI?: Maybe<EconomicSolvencyI>;
	economicSolvencyIi?: Maybe<EconomicSolvencyIi>;
	familyMemberPaymentExperienceIi?: Maybe<FamilyMemberPaymentExperienceIi>;
	recoveryTimeInYears?: Maybe<RecoveryTimeInYears>;
	totalScore?: Maybe<Scalars['Int']['output']>;
};

export type ExpectedProfitForNewVehicles = {
	__typename?: 'ExpectedProfitForNewVehicles';
	dailyDriverSalary?: Maybe<Scalars['Money']['output']>;
	dailyFareIncome?: Maybe<Scalars['Money']['output']>;
	dailyGasExpenses?: Maybe<Scalars['Money']['output']>;
	monthlyMaintenanceExpenses?: Maybe<Scalars['Money']['output']>;
	monthlyNetProfit?: Maybe<Scalars['Money']['output']>;
	monthlyVehicleRent?: Maybe<Scalars['Money']['output']>;
};

export enum FamilyMemberPaymentExperienceIi {
	NINETY_ONE_DAYS = 'NINETY_ONE_DAYS',
	ONE_DAY = 'ONE_DAY',
	SIXTY_ONE_DAYS = 'SIXTY_ONE_DAYS',
	THIRTY_ONE_DAYS = 'THIRTY_ONE_DAYS'
}

export type FillEvaluationMatrixInput = {
	applicantPaymentExperienceI: ApplicantPaymentExperienceI;
	applicantPaymentExperienceIi: ApplicantPaymentExperienceIi;
	economicSolvencyI: EconomicSolvencyI;
	economicSolvencyIi: EconomicSolvencyIi;
	familyMemberPaymentExperienceIi: FamilyMemberPaymentExperienceIi;
	recoveryTimeInYears: RecoveryTimeInYears;
	requestId: Scalars['UUID7']['input'];
};

export type FillEvaluationMatrixPayload = {
	__typename?: 'FillEvaluationMatrixPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export enum HouseType {
	FAMILY = 'FAMILY',
	MORTGAGED = 'MORTGAGED',
	OWNED = 'OWNED',
	RENTED = 'RENTED'
}

/** The action was not allowed for a given reason. */
export type InvalidAction = {
	__typename?: 'InvalidAction';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Provided input is not valid. */
export type InvalidInput = {
	__typename?: 'InvalidInput';
	/** Validation context. */
	context: Array<Maybe<InvalidInputContext>>;
	/** Invalid input field's name. */
	field: Scalars['String']['output'];
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Parameter taken into consideration for the validation. */
export type InvalidInputContext = {
	__typename?: 'InvalidInputContext';
	key: Scalars['String']['output'];
	value?: Maybe<Scalars['String']['output']>;
};

export type ModifyVanCreditInput = {
	creditId: Scalars['UUID7']['input'];
	expectedDisbursementDate: Scalars['Date']['input'];
	requestId: Scalars['UUID7']['input'];
};

export type ModifyVanCreditPayload = {
	__typename?: 'ModifyVanCreditPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type MonthlyBusinessExpenses = {
	__typename?: 'MonthlyBusinessExpenses';
	electricBill?: Maybe<Scalars['Money']['output']>;
	equipmentMaintenance?: Maybe<Scalars['Money']['output']>;
	gas?: Maybe<Scalars['Money']['output']>;
	inputsPurchase?: Maybe<Scalars['Money']['output']>;
	internetBill?: Maybe<Scalars['Money']['output']>;
	rent?: Maybe<Scalars['Money']['output']>;
	salaries?: Maybe<Scalars['Money']['output']>;
	totalBusinessExpenses?: Maybe<Scalars['Money']['output']>;
};

export type MonthlyHouseExpenses = {
	__typename?: 'MonthlyHouseExpenses';
	electricBill?: Maybe<Scalars['Money']['output']>;
	familyExpenses?: Maybe<Scalars['Money']['output']>;
	groceries?: Maybe<Scalars['Money']['output']>;
	internetBill?: Maybe<Scalars['Money']['output']>;
	rent?: Maybe<Scalars['Money']['output']>;
	totalHouseExpenses?: Maybe<Scalars['Money']['output']>;
	tuitions?: Maybe<Scalars['Money']['output']>;
	waterBill?: Maybe<Scalars['Money']['output']>;
};

export type MonthlyIncomeInformation = {
	__typename?: 'MonthlyIncomeInformation';
	businessSales?: Maybe<Scalars['Money']['output']>;
	familyContributionsIncome?: Maybe<Scalars['Money']['output']>;
	otherSourcesIncome?: Maybe<Scalars['Money']['output']>;
	otherSourcesIncomeDetail?: Maybe<Scalars['String']['output']>;
	salary?: Maybe<Scalars['Money']['output']>;
	totalIncome?: Maybe<Scalars['Money']['output']>;
};

/** Common errors for any mutation. */
export type MutationError = ActionFailed | InvalidAction | InvalidInput;

export type Node = {
	/** The ID of the object. */
	id: Scalars['ID']['output'];
};

export enum OldestDuePayment {
	CODE_00 = 'CODE_00',
	CODE_01 = 'CODE_01',
	CODE_02 = 'CODE_02',
	CODE_03 = 'CODE_03',
	CODE_04 = 'CODE_04',
	CODE_05 = 'CODE_05',
	CODE_06 = 'CODE_06',
	CODE_07 = 'CODE_07',
	CODE_96 = 'CODE_96',
	CODE_97 = 'CODE_97',
	CODE_99 = 'CODE_99',
	CODE_UR = 'CODE_UR'
}

export enum OnboardingStatus {
	APPROVED = 'APPROVED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	IN_PROCESS = 'IN_PROCESS',
	PENDING_REVIEW = 'PENDING_REVIEW',
	REJECTED = 'REJECTED'
}

export enum OperatingTimeRanges {
	BETWEEN_SIXTH_AND_TENTH_YEAR = 'BETWEEN_SIXTH_AND_TENTH_YEAR',
	IN_FIFTH_YEAR = 'IN_FIFTH_YEAR',
	IN_FIRST_YEAR = 'IN_FIRST_YEAR',
	IN_FOURTH_YEAR = 'IN_FOURTH_YEAR',
	IN_SECOND_YEAR = 'IN_SECOND_YEAR',
	IN_THIRD_YEAR = 'IN_THIRD_YEAR',
	MORE_THAN_TEN_YEARS = 'MORE_THAN_TEN_YEARS'
}

export type OtherCredits = {
	__typename?: 'OtherCredits';
	currentTotalDebt?: Maybe<Scalars['Money']['output']>;
	monthlyPaymentToCredits?: Maybe<Scalars['Money']['output']>;
};

export type PageInfo = {
	__typename?: 'PageInfo';
	/** When paginating forwards, the cursor to continue. */
	endCursor?: Maybe<Scalars['String']['output']>;
	/** When paginating forwards, are there more items? */
	hasNextPage: Scalars['Boolean']['output'];
	/** When paginating backwards, are there more items? */
	hasPreviousPage: Scalars['Boolean']['output'];
	/** When paginating backwards, the cursor to continue. */
	startCursor?: Maybe<Scalars['String']['output']>;
};

export type PassVanRequestToCreditCommitteeInput = {
	creditAreaOpinion: Scalars['String']['input'];
	requestId: Scalars['UUID7']['input'];
};

export type PassVanRequestToCreditCommitteePayload = {
	__typename?: 'PassVanRequestToCreditCommitteePayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type PersonalInformation = {
	__typename?: 'PersonalInformation';
	childDependants?: Maybe<Scalars['Int']['output']>;
	houseType?: Maybe<HouseType>;
	livesWithWhichFamilyMember?: Maybe<Scalars['String']['output']>;
	otherFamilyDependants?: Maybe<Scalars['Int']['output']>;
	otherFamilyDependantsExplanation?: Maybe<Scalars['String']['output']>;
	partnerActivity?: Maybe<Scalars['String']['output']>;
	partnerHasAJob?: Maybe<Scalars['Boolean']['output']>;
	transportationMethod?: Maybe<TransportationMethod>;
};

export enum RecoveryTimeInYears {
	LESS_FIVE_YEARS = 'LESS_FIVE_YEARS',
	LESS_SIX_YEARS = 'LESS_SIX_YEARS',
	MORE_SEVEN_YEARS = 'MORE_SEVEN_YEARS',
	MORE_SIX_YEARS = 'MORE_SIX_YEARS'
}

export type RejectRequestByCreditCommitteeInput = {
	committeeDeliberation: Scalars['String']['input'];
	requestId: Scalars['UUID7']['input'];
};

export type RejectRequestByCreditCommitteePayload = {
	__typename?: 'RejectRequestByCreditCommitteePayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RejectVanCreditRequestInput = {
	rejectionReason?: InputMaybe<Scalars['String']['input']>;
	requestId: Scalars['UUID7']['input'];
};

export type RejectVanCreditRequestPayload = {
	__typename?: 'RejectVanCreditRequestPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

/** Request */
export type Request = Node & {
	__typename?: 'Request';
	activityOrBusinessInformation?: Maybe<ActivityOrBusinessInformation>;
	applicantComprehensiveOperativeEfficiency?: Maybe<Scalars['Decimal']['output']>;
	businessComprehensiveOperativeEfficiency?: Maybe<Scalars['Decimal']['output']>;
	calculatedNetIncome?: Maybe<Scalars['Money']['output']>;
	calculatedNetIncomeIndex?: Maybe<Scalars['Decimal']['output']>;
	callComments?: Maybe<Scalars['String']['output']>;
	clientId?: Maybe<Scalars['ID']['output']>;
	committeeDeliberation?: Maybe<Scalars['String']['output']>;
	committeeRequestedChanges?: Maybe<Scalars['String']['output']>;
	committeeRuling?: Maybe<CommitteeRuling>;
	creditAccountDetails?: Maybe<CreditAccountDetails>;
	creditAreaOpinion?: Maybe<Scalars['String']['output']>;
	creditBureauReport?: Maybe<CreditBureauReport>;
	creditDetails?: Maybe<CreditDetails>;
	creditId?: Maybe<Scalars['ID']['output']>;
	economicSolvencyI?: Maybe<Scalars['Decimal']['output']>;
	economicSolvencyIi?: Maybe<Scalars['Decimal']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	evaluationMatrix?: Maybe<EvaluationMatrix>;
	expectedDisbursementDate?: Maybe<Scalars['Date']['output']>;
	expectedProfitForNewVehicles?: Maybe<ExpectedProfitForNewVehicles>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	/** The ID of an object */
	id: Scalars['ID']['output'];
	monthlyBusinessExpenses?: Maybe<MonthlyBusinessExpenses>;
	monthlyHouseExpenses?: Maybe<MonthlyHouseExpenses>;
	monthlyIncomeInformation?: Maybe<MonthlyIncomeInformation>;
	names?: Maybe<Scalars['String']['output']>;
	onboardingRegistryDeliberation?: Maybe<Scalars['String']['output']>;
	onboardingStatus?: Maybe<OnboardingStatus>;
	openfinCuenta?: Maybe<Scalars['String']['output']>;
	openfinIdasociado?: Maybe<Scalars['String']['output']>;
	otherCredits?: Maybe<OtherCredits>;
	personalInformation?: Maybe<PersonalInformation>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	recoveryTimeInYears?: Maybe<Scalars['Decimal']['output']>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	requestId?: Maybe<Scalars['ID']['output']>;
	requestStatus?: Maybe<RequestStatus>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	simulation?: Maybe<Simulation>;
	startedAt?: Maybe<Scalars['DateTime']['output']>;
	valueOfAssets?: Maybe<ValueOfAssets>;
	vehicleValue?: Maybe<Scalars['Money']['output']>;
};

export type RequestConnection = {
	__typename?: 'RequestConnection';
	count?: Maybe<Scalars['Int']['output']>;
	edges?: Maybe<Array<Maybe<RequestEdge>>>;
	pageInfo: PageInfo;
};

export type RequestConnectionCountArgs = {
	filter?: InputMaybe<RequestFilter>;
};

export type RequestEdge = {
	__typename?: 'RequestEdge';
	cursor?: Maybe<Scalars['String']['output']>;
	node?: Maybe<Request>;
};

export type RequestFilter = {
	onboardingStatus?: InputMaybe<Array<InputMaybe<OnboardingStatus>>>;
	requestStatus?: InputMaybe<Array<InputMaybe<RequestStatus>>>;
	searchTerm?: InputMaybe<Scalars['String']['input']>;
	startedAt?: InputMaybe<DatetimeRange>;
};

export type RequestSort = {
	expectedDisbursementDate?: InputMaybe<SortDirection>;
	requestStatus?: InputMaybe<SortDirection>;
	startedAt?: InputMaybe<SortDirection>;
};

export enum RequestStatus {
	ACTIVITY_INFORMATION_REGISTERED = 'ACTIVITY_INFORMATION_REGISTERED',
	APPROVED_BY_CREDIT_COMMITTEE = 'APPROVED_BY_CREDIT_COMMITTEE',
	COMPLETED = 'COMPLETED',
	CREATED = 'CREATED',
	CREDIT_DETAILS_REGISTERED = 'CREDIT_DETAILS_REGISTERED',
	EXPECTED_PROFIT_FOR_NEW_VEHICLES_REGISTERED = 'EXPECTED_PROFIT_FOR_NEW_VEHICLES_REGISTERED',
	IN_REVIEW = 'IN_REVIEW',
	MONTHLY_BUSINESS_EXPENSES_REGISTERED = 'MONTHLY_BUSINESS_EXPENSES_REGISTERED',
	MONTHLY_HOUSE_EXPENSES_REGISTERED = 'MONTHLY_HOUSE_EXPENSES_REGISTERED',
	MONTHLY_INCOME_INFORMATION_REGISTERED = 'MONTHLY_INCOME_INFORMATION_REGISTERED',
	OTHER_CREDITS_REGISTERED = 'OTHER_CREDITS_REGISTERED',
	PASSED_TO_CREDIT_COMMITTEE = 'PASSED_TO_CREDIT_COMMITTEE',
	PERSONAL_INFORMATION_REGISTERED = 'PERSONAL_INFORMATION_REGISTERED',
	REJECTED = 'REJECTED',
	REJECTED_BY_CREDIT_COMMITTEE = 'REJECTED_BY_CREDIT_COMMITTEE',
	SIGNED_DOCUMENTS_UPLOADED = 'SIGNED_DOCUMENTS_UPLOADED',
	VALUE_OF_ASSETS_REGISTERED = 'VALUE_OF_ASSETS_REGISTERED'
}

export type ReviewActivityOrBusinessInformationInput = {
	activityDetail?: InputMaybe<Scalars['String']['input']>;
	activityType?: InputMaybe<Scalars['String']['input']>;
	requestId: Scalars['UUID7']['input'];
	startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ReviewActivityOrBusinessInformationPayload = {
	__typename?: 'ReviewActivityOrBusinessInformationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewCreditDetailsInput = {
	amountRequested?: InputMaybe<Scalars['Money']['input']>;
	downPaymentAmount?: InputMaybe<Scalars['Money']['input']>;
	downPaymentPercentage?: InputMaybe<Scalars['Decimal']['input']>;
	expectedAdditionalIncome?: InputMaybe<Scalars['Money']['input']>;
	requestId: Scalars['UUID7']['input'];
	term?: InputMaybe<Scalars['Int']['input']>;
	vehiclesRequested?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewCreditDetailsPayload = {
	__typename?: 'ReviewCreditDetailsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewExpectedProfitForNewVehiclesInput = {
	dailyDriverSalary?: InputMaybe<Scalars['Money']['input']>;
	dailyFareIncome?: InputMaybe<Scalars['Money']['input']>;
	dailyGasExpenses?: InputMaybe<Scalars['Money']['input']>;
	monthlyMaintenanceExpenses?: InputMaybe<Scalars['Money']['input']>;
	monthlyNetProfit?: InputMaybe<Scalars['Money']['input']>;
	monthlyVehicleRent?: InputMaybe<Scalars['Money']['input']>;
	requestId: Scalars['UUID7']['input'];
};

export type ReviewExpectedProfitForNewVehiclesPayload = {
	__typename?: 'ReviewExpectedProfitForNewVehiclesPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMonthlyBusinessExpensesInput = {
	electricBill?: InputMaybe<Scalars['Money']['input']>;
	equipmentMaintenance?: InputMaybe<Scalars['Money']['input']>;
	gas?: InputMaybe<Scalars['Money']['input']>;
	inputsPurchase?: InputMaybe<Scalars['Money']['input']>;
	internetBill?: InputMaybe<Scalars['Money']['input']>;
	rent?: InputMaybe<Scalars['Money']['input']>;
	requestId: Scalars['UUID7']['input'];
	salaries?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMonthlyBusinessExpensesPayload = {
	__typename?: 'ReviewMonthlyBusinessExpensesPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMonthlyHouseExpensesInput = {
	electricBill?: InputMaybe<Scalars['Money']['input']>;
	familyExpenses?: InputMaybe<Scalars['Money']['input']>;
	groceries?: InputMaybe<Scalars['Money']['input']>;
	internetBill?: InputMaybe<Scalars['Money']['input']>;
	rent?: InputMaybe<Scalars['Money']['input']>;
	requestId: Scalars['UUID7']['input'];
	tuitions?: InputMaybe<Scalars['Money']['input']>;
	waterBill?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMonthlyHouseExpensesPayload = {
	__typename?: 'ReviewMonthlyHouseExpensesPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewMonthlyIncomeInformationInput = {
	businessSales?: InputMaybe<Scalars['Money']['input']>;
	familyContributionsIncome?: InputMaybe<Scalars['Money']['input']>;
	otherSourcesIncome?: InputMaybe<Scalars['Money']['input']>;
	otherSourcesIncomeDetail?: InputMaybe<Scalars['String']['input']>;
	requestId: Scalars['UUID7']['input'];
	salary?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewMonthlyIncomeInformationPayload = {
	__typename?: 'ReviewMonthlyIncomeInformationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewOtherCreditsInput = {
	currentTotalDebt?: InputMaybe<Scalars['Money']['input']>;
	monthlyPaymentToCredits?: InputMaybe<Scalars['Money']['input']>;
	requestId: Scalars['UUID7']['input'];
};

export type ReviewOtherCreditsPayload = {
	__typename?: 'ReviewOtherCreditsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewPersonalInformationInput = {
	childDependants?: InputMaybe<Scalars['Int']['input']>;
	houseType?: InputMaybe<HouseType>;
	livesWithWhichFamilyMember?: InputMaybe<Scalars['String']['input']>;
	otherFamilyDependants?: InputMaybe<Scalars['Int']['input']>;
	otherFamilyDependantsExplanation?: InputMaybe<Scalars['String']['input']>;
	partnerActivity?: InputMaybe<Scalars['String']['input']>;
	partnerHasAJob?: InputMaybe<Scalars['Boolean']['input']>;
	requestId: Scalars['UUID7']['input'];
	transportationMethod?: InputMaybe<TransportationMethod>;
};

export type ReviewPersonalInformationPayload = {
	__typename?: 'ReviewPersonalInformationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewRequestCallCommentsInput = {
	callComments?: InputMaybe<Scalars['String']['input']>;
	requestId: Scalars['UUID7']['input'];
};

export type ReviewRequestCallCommentsPayload = {
	__typename?: 'ReviewRequestCallCommentsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type ReviewValueOfAssetsInput = {
	carsValue?: InputMaybe<Scalars['Money']['input']>;
	equipmentDetail?: InputMaybe<Scalars['String']['input']>;
	equipmentValue?: InputMaybe<Scalars['Money']['input']>;
	homeValue?: InputMaybe<Scalars['Money']['input']>;
	landValue?: InputMaybe<Scalars['Money']['input']>;
	requestId: Scalars['UUID7']['input'];
	savings?: InputMaybe<Scalars['Money']['input']>;
};

export type ReviewValueOfAssetsPayload = {
	__typename?: 'ReviewValueOfAssetsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	approveRequestByCreditCommittee?: Maybe<ApproveRequestByCreditCommitteePayload>;
	createVanCredit?: Maybe<CreateVanCreditPayload>;
	downloadContractOpenfinVanCredit?: Maybe<DownloadContractOpenfinVanCreditPayload>;
	fillEvaluationMatrix?: Maybe<FillEvaluationMatrixPayload>;
	modifyVanCredit?: Maybe<ModifyVanCreditPayload>;
	passVanRequestToCreditCommittee?: Maybe<PassVanRequestToCreditCommitteePayload>;
	rejectRequestByCreditCommittee?: Maybe<RejectRequestByCreditCommitteePayload>;
	rejectVanCreditRequest?: Maybe<RejectVanCreditRequestPayload>;
	reviewActivityOrBusinessInformation?: Maybe<ReviewActivityOrBusinessInformationPayload>;
	reviewCreditDetails?: Maybe<ReviewCreditDetailsPayload>;
	reviewExpectedProfitForNewVehicles?: Maybe<ReviewExpectedProfitForNewVehiclesPayload>;
	reviewMonthlyBusinessExpenses?: Maybe<ReviewMonthlyBusinessExpensesPayload>;
	reviewMonthlyHouseExpenses?: Maybe<ReviewMonthlyHouseExpensesPayload>;
	reviewMonthlyIncomeInformation?: Maybe<ReviewMonthlyIncomeInformationPayload>;
	reviewOtherCredits?: Maybe<ReviewOtherCreditsPayload>;
	reviewPersonalInformation?: Maybe<ReviewPersonalInformationPayload>;
	reviewRequestCallComments?: Maybe<ReviewRequestCallCommentsPayload>;
	reviewValueOfAssets?: Maybe<ReviewValueOfAssetsPayload>;
	signContractOpenfinVanCredit?: Maybe<SignContractOpenfinVanCreditPayload>;
	simulateVanCredit?: Maybe<SimulateVanCreditPayload>;
};

export type RootMutationTypeApproveRequestByCreditCommitteeArgs = {
	input: ApproveRequestByCreditCommitteeInput;
};

export type RootMutationTypeCreateVanCreditArgs = {
	input: CreateVanCreditInput;
};

export type RootMutationTypeDownloadContractOpenfinVanCreditArgs = {
	input: DownloadContractOpenfinVanCreditInput;
};

export type RootMutationTypeFillEvaluationMatrixArgs = {
	input: FillEvaluationMatrixInput;
};

export type RootMutationTypeModifyVanCreditArgs = {
	input: ModifyVanCreditInput;
};

export type RootMutationTypePassVanRequestToCreditCommitteeArgs = {
	input: PassVanRequestToCreditCommitteeInput;
};

export type RootMutationTypeRejectRequestByCreditCommitteeArgs = {
	input: RejectRequestByCreditCommitteeInput;
};

export type RootMutationTypeRejectVanCreditRequestArgs = {
	input: RejectVanCreditRequestInput;
};

export type RootMutationTypeReviewActivityOrBusinessInformationArgs = {
	input: ReviewActivityOrBusinessInformationInput;
};

export type RootMutationTypeReviewCreditDetailsArgs = {
	input: ReviewCreditDetailsInput;
};

export type RootMutationTypeReviewExpectedProfitForNewVehiclesArgs = {
	input: ReviewExpectedProfitForNewVehiclesInput;
};

export type RootMutationTypeReviewMonthlyBusinessExpensesArgs = {
	input: ReviewMonthlyBusinessExpensesInput;
};

export type RootMutationTypeReviewMonthlyHouseExpensesArgs = {
	input: ReviewMonthlyHouseExpensesInput;
};

export type RootMutationTypeReviewMonthlyIncomeInformationArgs = {
	input: ReviewMonthlyIncomeInformationInput;
};

export type RootMutationTypeReviewOtherCreditsArgs = {
	input: ReviewOtherCreditsInput;
};

export type RootMutationTypeReviewPersonalInformationArgs = {
	input: ReviewPersonalInformationInput;
};

export type RootMutationTypeReviewRequestCallCommentsArgs = {
	input: ReviewRequestCallCommentsInput;
};

export type RootMutationTypeReviewValueOfAssetsArgs = {
	input: ReviewValueOfAssetsInput;
};

export type RootMutationTypeSignContractOpenfinVanCreditArgs = {
	input: SignContractOpenfinVanCreditInput;
};

export type RootMutationTypeSimulateVanCreditArgs = {
	input: SimulateVanCreditInput;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	calculateFirstPaymentDate: Scalars['Date']['output'];
	downloadDocuments?: Maybe<DocumentDownload>;
	node?: Maybe<Node>;
	requests?: Maybe<RequestConnection>;
	tiieBanxicoValue?: Maybe<TiieBanxicoValue>;
};

export type RootQueryTypeCalculateFirstPaymentDateArgs = {
	daysPerPeriod: Scalars['Int']['input'];
	expectedDisbursementDate: Scalars['Date']['input'];
};

export type RootQueryTypeDownloadDocumentsArgs = {
	clientId: Scalars['ID']['input'];
	creditId: Scalars['ID']['input'];
	documentFormat: DocumentFormat;
};

export type RootQueryTypeNodeArgs = {
	id: Scalars['ID']['input'];
};

export type RootQueryTypeRequestsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<RequestFilter>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<RequestSort>>>;
};

export type SignContractOpenfinVanCreditInput = {
	creditContract: Scalars['Upload']['input'];
	creditId: Scalars['UUID7']['input'];
	promissoryNote: Scalars['Upload']['input'];
};

export type SignContractOpenfinVanCreditPayload = {
	__typename?: 'SignContractOpenfinVanCreditPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type SimulateVanCreditInput = {
	amountRequested: Scalars['Money']['input'];
	basisPoints: Scalars['Decimal']['input'];
	daysPerPeriod: DaysPerSimulationPeriod;
	firstPaymentDate: Scalars['Date']['input'];
	gpsAmount?: InputMaybe<Scalars['Money']['input']>;
	insuranceAmount?: InputMaybe<Scalars['Money']['input']>;
	paymentCapacity: Scalars['Money']['input'];
	percentageOfCreditToSettle: Scalars['Decimal']['input'];
	requestId: Scalars['UUID7']['input'];
	sameDayPayment: Scalars['Boolean']['input'];
};

export type SimulateVanCreditPayload = {
	__typename?: 'SimulateVanCreditPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type Simulation = {
	__typename?: 'Simulation';
	configuration?: Maybe<SimulationConfiguration>;
	daysPerPeriod?: Maybe<DaysPerSimulationPeriod>;
	generatedAt?: Maybe<Scalars['DateTime']['output']>;
	installments?: Maybe<Array<Maybe<SimulationInstallment>>>;
	lastPaymentAmount?: Maybe<Scalars['Money']['output']>;
	numberOfPeriods?: Maybe<Scalars['Int']['output']>;
	paymentCapacity?: Maybe<Scalars['Money']['output']>;
};

export type SimulationConfiguration = {
	__typename?: 'SimulationConfiguration';
	amountRequested?: Maybe<Scalars['Money']['output']>;
	basisPoints?: Maybe<Scalars['Decimal']['output']>;
	daysPerPeriod?: Maybe<Scalars['Int']['output']>;
	firstPaymentDate?: Maybe<Scalars['Date']['output']>;
	gpsAmount?: Maybe<Scalars['Money']['output']>;
	highestAmountToApprove?: Maybe<Scalars['Money']['output']>;
	insuranceAmount?: Maybe<Scalars['Money']['output']>;
	maximumNumberOfPeriods?: Maybe<Scalars['Int']['output']>;
	minimumPaymentToSettleTheCreditPercentage?: Maybe<Scalars['Money']['output']>;
	minimumPaymentToSettleTheCreditTotal?: Maybe<Scalars['Money']['output']>;
	ordinaryInterestRate?: Maybe<Scalars['Decimal']['output']>;
	paymentCapacity?: Maybe<Scalars['Money']['output']>;
	paymentPeriodOrdinaryInterestRate?: Maybe<Scalars['Decimal']['output']>;
	percentageOfCreditToSettle?: Maybe<Scalars['Decimal']['output']>;
	sameDayPayment?: Maybe<Scalars['Boolean']['output']>;
	tiieDate?: Maybe<Scalars['Date']['output']>;
	tiieValue?: Maybe<Scalars['Decimal']['output']>;
};

export type SimulationInstallment = {
	__typename?: 'SimulationInstallment';
	creditPayment?: Maybe<Scalars['Money']['output']>;
	dueDate?: Maybe<Scalars['Date']['output']>;
	gpsAmount?: Maybe<Scalars['Money']['output']>;
	gpsTax?: Maybe<Scalars['Money']['output']>;
	initialBalance?: Maybe<Scalars['Money']['output']>;
	insuranceAmount?: Maybe<Scalars['Money']['output']>;
	insuranceTax?: Maybe<Scalars['Money']['output']>;
	interestPayment?: Maybe<Scalars['Money']['output']>;
	interestTax?: Maybe<Scalars['Money']['output']>;
	outstandingBalance?: Maybe<Scalars['Money']['output']>;
	paymentNumber?: Maybe<Scalars['Int']['output']>;
	principalPayment?: Maybe<Scalars['Money']['output']>;
	totalPayment?: Maybe<Scalars['Money']['output']>;
};

export enum SortDirection {
	/** Ascending */
	ASC = 'ASC',
	/** Descending */
	DESC = 'DESC'
}

export type TiieBanxicoValue = {
	__typename?: 'TiieBanxicoValue';
	date?: Maybe<Scalars['Date']['output']>;
	value?: Maybe<Scalars['Decimal']['output']>;
};

export enum TransportationMethod {
	BIKE = 'BIKE',
	CAR = 'CAR',
	PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
	WALK = 'WALK'
}

export type ValueOfAssets = {
	__typename?: 'ValueOfAssets';
	carsValue?: Maybe<Scalars['Money']['output']>;
	equipmentDetail?: Maybe<Scalars['String']['output']>;
	equipmentValue?: Maybe<Scalars['Money']['output']>;
	homeValue?: Maybe<Scalars['Money']['output']>;
	landValue?: Maybe<Scalars['Money']['output']>;
	savings?: Maybe<Scalars['Money']['output']>;
	totalValueOfAssets?: Maybe<Scalars['Money']['output']>;
};

export type VanCreditReviewMutationVariables = Exact<{
	callCommentsInput: ReviewRequestCallCommentsInput;
	personalInformationInput: ReviewPersonalInformationInput;
	monthlyIncomeInformationInput: ReviewMonthlyIncomeInformationInput;
	monthlyHouseExpensesInput: ReviewMonthlyHouseExpensesInput;
	monthlyBusinessExpensesInput: ReviewMonthlyBusinessExpensesInput;
	otherCreditsInput: ReviewOtherCreditsInput;
	activityOrBusinessInformationInput: ReviewActivityOrBusinessInformationInput;
	creditDetailsInput: ReviewCreditDetailsInput;
	valueOfAssetsInput: ReviewValueOfAssetsInput;
	expectedProfitForNewVehiclesInput: ReviewExpectedProfitForNewVehiclesInput;
}>;

export type VanCreditReviewMutation = {
	__typename?: 'RootMutationType';
	reviewRequestCallComments?: {
		__typename?: 'ReviewRequestCallCommentsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewCreditDetails?: {
		__typename?: 'ReviewCreditDetailsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewPersonalInformation?: {
		__typename?: 'ReviewPersonalInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMonthlyIncomeInformation?: {
		__typename?: 'ReviewMonthlyIncomeInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMonthlyHouseExpenses?: {
		__typename?: 'ReviewMonthlyHouseExpensesPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewMonthlyBusinessExpenses?: {
		__typename?: 'ReviewMonthlyBusinessExpensesPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewOtherCredits?: {
		__typename?: 'ReviewOtherCreditsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewActivityOrBusinessInformation?: {
		__typename?: 'ReviewActivityOrBusinessInformationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewValueOfAssets?: {
		__typename?: 'ReviewValueOfAssetsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
	reviewExpectedProfitForNewVehicles?: {
		__typename?: 'ReviewExpectedProfitForNewVehiclesPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type SimulateVanCreditMutationVariables = Exact<{
	input: SimulateVanCreditInput;
}>;

export type SimulateVanCreditMutation = {
	__typename?: 'RootMutationType';
	simulateVanCredit?: {
		__typename?: 'SimulateVanCreditPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type RejectVanCreditRequestMutationVariables = Exact<{
	input: RejectVanCreditRequestInput;
}>;

export type RejectVanCreditRequestMutation = {
	__typename?: 'RootMutationType';
	rejectVanCreditRequest?: {
		__typename?: 'RejectVanCreditRequestPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type FillEvaluationMatrixMutationVariables = Exact<{
	input: FillEvaluationMatrixInput;
}>;

export type FillEvaluationMatrixMutation = {
	__typename?: 'RootMutationType';
	fillEvaluationMatrix?: {
		__typename?: 'FillEvaluationMatrixPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type PassVanRequestToCreditCommitteeMutationVariables = Exact<{
	input: PassVanRequestToCreditCommitteeInput;
}>;

export type PassVanRequestToCreditCommitteeMutation = {
	__typename?: 'RootMutationType';
	passVanRequestToCreditCommittee?: {
		__typename?: 'PassVanRequestToCreditCommitteePayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ApproveRequestByCreditCommitteeMutationVariables = Exact<{
	input: ApproveRequestByCreditCommitteeInput;
}>;

export type ApproveRequestByCreditCommitteeMutation = {
	__typename?: 'RootMutationType';
	approveRequestByCreditCommittee?: {
		__typename?: 'ApproveRequestByCreditCommitteePayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type RejectRequestByCreditCommitteeMutationVariables = Exact<{
	input: RejectRequestByCreditCommitteeInput;
}>;

export type RejectRequestByCreditCommitteeMutation = {
	__typename?: 'RootMutationType';
	rejectRequestByCreditCommittee?: {
		__typename?: 'RejectRequestByCreditCommitteePayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type CreateVanCreditMutationVariables = Exact<{
	input: CreateVanCreditInput;
}>;

export type CreateVanCreditMutation = {
	__typename?: 'RootMutationType';
	createVanCredit?: {
		__typename?: 'CreateVanCreditPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ModifyVanCreditMutationVariables = Exact<{
	input: ModifyVanCreditInput;
}>;

export type ModifyVanCreditMutation = {
	__typename?: 'RootMutationType';
	modifyVanCredit?: {
		__typename?: 'ModifyVanCreditPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type SignContractOpenfinVanCreditMutationVariables = Exact<{
	input: SignContractOpenfinVanCreditInput;
}>;

export type SignContractOpenfinVanCreditMutation = {
	__typename?: 'RootMutationType';
	signContractOpenfinVanCredit?: {
		__typename?: 'SignContractOpenfinVanCreditPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type DownloadContractOpenfinVanCreditMutationVariables = Exact<{
	input: DownloadContractOpenfinVanCreditInput;
}>;

export type DownloadContractOpenfinVanCreditMutation = {
	__typename?: 'RootMutationType';
	downloadContractOpenfinVanCredit?: {
		__typename?: 'DownloadContractOpenfinVanCreditPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
		result?: {
			__typename?: 'ContractOpenfinVanCredit';
			creditContract?: string | null;
			promissoryNote?: string | null;
		} | null;
	} | null;
};

export type GetVanCreditRequestQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetVanCreditRequestQuery = {
	__typename?: 'RootQueryType';
	node?: {
		__typename?: 'Request';
		id: string;
		requestId?: string | null;
		clientId?: string | null;
		names?: string | null;
		firstLastName?: string | null;
		secondLastName?: string | null;
		email?: string | null;
		phoneNumber?: string | null;
		requestStatus?: RequestStatus | null;
		calculatedNetIncome?: string | null;
		startedAt?: string | null;
		onboardingStatus?: OnboardingStatus | null;
		onboardingRegistryDeliberation?: string | null;
		callComments?: string | null;
		rejectionReason?: string | null;
		calculatedNetIncomeIndex?: string | null;
		recoveryTimeInYears?: string | null;
		economicSolvencyI?: string | null;
		economicSolvencyIi?: string | null;
		applicantComprehensiveOperativeEfficiency?: string | null;
		businessComprehensiveOperativeEfficiency?: string | null;
		vehicleValue?: string | null;
		creditAreaOpinion?: string | null;
		committeeDeliberation?: string | null;
		committeeRequestedChanges?: string | null;
		committeeRuling?: CommitteeRuling | null;
		openfinCuenta?: string | null;
		openfinIdasociado?: string | null;
		expectedDisbursementDate?: string | null;
		creditId?: string | null;
		personalInformation?: {
			__typename?: 'PersonalInformation';
			houseType?: HouseType | null;
			livesWithWhichFamilyMember?: string | null;
			transportationMethod?: TransportationMethod | null;
			childDependants?: number | null;
			otherFamilyDependants?: number | null;
			otherFamilyDependantsExplanation?: string | null;
			partnerHasAJob?: boolean | null;
			partnerActivity?: string | null;
		} | null;
		activityOrBusinessInformation?: {
			__typename?: 'ActivityOrBusinessInformation';
			activityType?: string | null;
			startDate?: string | null;
			activityDetail?: string | null;
			operatingTimeRange?: OperatingTimeRanges | null;
		} | null;
		creditDetails?: {
			__typename?: 'CreditDetails';
			vehiclesRequested?: string | null;
			term?: number | null;
			downPaymentPercentage?: string | null;
			downPaymentAmount?: string | null;
			expectedAdditionalIncome?: string | null;
			amountRequested?: string | null;
		} | null;
		monthlyIncomeInformation?: {
			__typename?: 'MonthlyIncomeInformation';
			businessSales?: string | null;
			salary?: string | null;
			familyContributionsIncome?: string | null;
			otherSourcesIncome?: string | null;
			otherSourcesIncomeDetail?: string | null;
			totalIncome?: string | null;
		} | null;
		monthlyBusinessExpenses?: {
			__typename?: 'MonthlyBusinessExpenses';
			rent?: string | null;
			electricBill?: string | null;
			internetBill?: string | null;
			equipmentMaintenance?: string | null;
			inputsPurchase?: string | null;
			salaries?: string | null;
			gas?: string | null;
			totalBusinessExpenses?: string | null;
		} | null;
		monthlyHouseExpenses?: {
			__typename?: 'MonthlyHouseExpenses';
			rent?: string | null;
			electricBill?: string | null;
			internetBill?: string | null;
			waterBill?: string | null;
			groceries?: string | null;
			tuitions?: string | null;
			familyExpenses?: string | null;
			totalHouseExpenses?: string | null;
		} | null;
		valueOfAssets?: {
			__typename?: 'ValueOfAssets';
			homeValue?: string | null;
			landValue?: string | null;
			carsValue?: string | null;
			equipmentValue?: string | null;
			equipmentDetail?: string | null;
			savings?: string | null;
			totalValueOfAssets?: string | null;
		} | null;
		otherCredits?: {
			__typename?: 'OtherCredits';
			currentTotalDebt?: string | null;
			monthlyPaymentToCredits?: string | null;
		} | null;
		creditBureauReport?: {
			__typename?: 'CreditBureauReport';
			reportDate?: string | null;
			firstCreditDate?: string | null;
			oldestDuePayment?: OldestDuePayment | null;
			totalCreditBalance?: string | null;
			totalActiveCreditBalance?: string | null;
			totalNumberOfCredits?: number | null;
			totalActiveNumberOfCredits?: number | null;
			creditBureauScore?: number | null;
		} | null;
		expectedProfitForNewVehicles?: {
			__typename?: 'ExpectedProfitForNewVehicles';
			dailyFareIncome?: string | null;
			dailyGasExpenses?: string | null;
			dailyDriverSalary?: string | null;
			monthlyMaintenanceExpenses?: string | null;
			monthlyNetProfit?: string | null;
			monthlyVehicleRent?: string | null;
		} | null;
		simulation?: {
			__typename?: 'Simulation';
			numberOfPeriods?: number | null;
			daysPerPeriod?: DaysPerSimulationPeriod | null;
			paymentCapacity?: string | null;
			lastPaymentAmount?: string | null;
			generatedAt?: string | null;
			configuration?: {
				__typename?: 'SimulationConfiguration';
				amountRequested?: string | null;
				paymentCapacity?: string | null;
				daysPerPeriod?: number | null;
				maximumNumberOfPeriods?: number | null;
				ordinaryInterestRate?: string | null;
				firstPaymentDate?: string | null;
				sameDayPayment?: boolean | null;
				percentageOfCreditToSettle?: string | null;
				gpsAmount?: string | null;
				insuranceAmount?: string | null;
				basisPoints?: string | null;
				tiieValue?: string | null;
				tiieDate?: string | null;
				highestAmountToApprove?: string | null;
				minimumPaymentToSettleTheCreditTotal?: string | null;
				minimumPaymentToSettleTheCreditPercentage?: string | null;
			} | null;
			installments?: Array<{
				__typename?: 'SimulationInstallment';
				paymentNumber?: number | null;
				dueDate?: string | null;
				initialBalance?: string | null;
				creditPayment?: string | null;
				principalPayment?: string | null;
				interestPayment?: string | null;
				interestTax?: string | null;
				totalPayment?: string | null;
				outstandingBalance?: string | null;
				gpsAmount?: string | null;
				gpsTax?: string | null;
				insuranceAmount?: string | null;
				insuranceTax?: string | null;
			} | null> | null;
		} | null;
		evaluationMatrix?: {
			__typename?: 'EvaluationMatrix';
			applicantPaymentExperienceI?: ApplicantPaymentExperienceI | null;
			applicantPaymentExperienceIi?: ApplicantPaymentExperienceIi | null;
			recoveryTimeInYears?: RecoveryTimeInYears | null;
			economicSolvencyI?: EconomicSolvencyI | null;
			economicSolvencyIi?: EconomicSolvencyIi | null;
			familyMemberPaymentExperienceIi?: FamilyMemberPaymentExperienceIi | null;
			totalScore?: number | null;
		} | null;
		creditAccountDetails?: {
			__typename?: 'CreditAccountDetails';
			amountRequested?: string | null;
			ordinaryInterestRate?: string | null;
			numberOfPeriods?: number | null;
			daysPerPeriod?: number | null;
			sameDayPayment?: boolean | null;
			firstPaymentDate?: string | null;
			basisPoints?: string | null;
			tiieValue?: string | null;
			tiieDate?: string | null;
			gpsAmount?: string | null;
			insuranceAmount?: string | null;
		} | null;
	} | null;
};

export type VanCreditRequestsQueryVariables = Exact<{
	after?: InputMaybe<Scalars['String']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<RequestSort>> | InputMaybe<RequestSort>>;
	filter?: InputMaybe<RequestFilter>;
}>;

export type VanCreditRequestsQuery = {
	__typename?: 'RootQueryType';
	requests?: {
		__typename?: 'RequestConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'RequestEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'Request';
				id: string;
				onboardingStatus?: OnboardingStatus | null;
				requestStatus?: RequestStatus | null;
				clientId?: string | null;
				requestId?: string | null;
				names?: string | null;
				firstLastName?: string | null;
				secondLastName?: string | null;
				phoneNumber?: string | null;
				email?: string | null;
				startedAt?: string | null;
				expectedDisbursementDate?: string | null;
				creditDetails?: { __typename?: 'CreditDetails'; vehiclesRequested?: string | null } | null;
			} | null;
		} | null> | null;
	} | null;
};

export type TiieBanxicoQueryVariables = Exact<{ [key: string]: never }>;

export type TiieBanxicoQuery = {
	__typename?: 'RootQueryType';
	tiieBanxicoValue?: {
		__typename?: 'TiieBanxicoValue';
		value?: string | null;
		date?: string | null;
	} | null;
};

export type CalculateFirstPaymentDateQueryVariables = Exact<{
	expectedDisbursementDate: Scalars['Date']['input'];
	daysPerPeriod: Scalars['Int']['input'];
}>;

export type CalculateFirstPaymentDateQuery = {
	__typename?: 'RootQueryType';
	calculateFirstPaymentDate: string;
};

export type DownloadVanCreditDocumentsQueryVariables = Exact<{
	clientId: Scalars['ID']['input'];
	creditId: Scalars['ID']['input'];
	documentFormat: DocumentFormat;
}>;

export type DownloadVanCreditDocumentsQuery = {
	__typename?: 'RootQueryType';
	downloadDocuments?: { __typename?: 'DocumentDownload'; pdfBase64?: string | null } | null;
};

export const VanCreditReviewDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'VanCreditReview' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'callCommentsInput' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewRequestCallCommentsInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'personalInformationInput' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewPersonalInformationInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'monthlyIncomeInformationInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMonthlyIncomeInformationInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'monthlyHouseExpensesInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMonthlyHouseExpensesInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'monthlyBusinessExpensesInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewMonthlyBusinessExpensesInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'otherCreditsInput' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReviewOtherCreditsInput' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'activityOrBusinessInformationInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewActivityOrBusinessInformationInput' }
						}
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'creditDetailsInput' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReviewCreditDetailsInput' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'valueOfAssetsInput' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ReviewValueOfAssetsInput' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'expectedProfitForNewVehiclesInput' }
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ReviewExpectedProfitForNewVehiclesInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewRequestCallComments' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'callCommentsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewCreditDetails' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'creditDetailsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewPersonalInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'personalInformationInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMonthlyIncomeInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'monthlyIncomeInformationInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMonthlyHouseExpenses' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'monthlyHouseExpensesInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewMonthlyBusinessExpenses' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'monthlyBusinessExpensesInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewOtherCredits' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'otherCreditsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewActivityOrBusinessInformation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'activityOrBusinessInformationInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewValueOfAssets' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'valueOfAssetsInput' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewExpectedProfitForNewVehicles' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'expectedProfitForNewVehiclesInput' }
								}
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type VanCreditReviewMutationFn = Apollo.MutationFunction<
	VanCreditReviewMutation,
	VanCreditReviewMutationVariables
>;

/**
 * __useVanCreditReviewMutation__
 *
 * To run a mutation, you first call `useVanCreditReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVanCreditReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vanCreditReviewMutation, { data, loading, error }] = useVanCreditReviewMutation({
 *   variables: {
 *      callCommentsInput: // value for 'callCommentsInput'
 *      personalInformationInput: // value for 'personalInformationInput'
 *      monthlyIncomeInformationInput: // value for 'monthlyIncomeInformationInput'
 *      monthlyHouseExpensesInput: // value for 'monthlyHouseExpensesInput'
 *      monthlyBusinessExpensesInput: // value for 'monthlyBusinessExpensesInput'
 *      otherCreditsInput: // value for 'otherCreditsInput'
 *      activityOrBusinessInformationInput: // value for 'activityOrBusinessInformationInput'
 *      creditDetailsInput: // value for 'creditDetailsInput'
 *      valueOfAssetsInput: // value for 'valueOfAssetsInput'
 *      expectedProfitForNewVehiclesInput: // value for 'expectedProfitForNewVehiclesInput'
 *   },
 * });
 */
export function useVanCreditReviewMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VanCreditReviewMutation,
		VanCreditReviewMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VanCreditReviewMutation, VanCreditReviewMutationVariables>(
		VanCreditReviewDocument,
		options
	);
}
export type VanCreditReviewMutationHookResult = ReturnType<typeof useVanCreditReviewMutation>;
export type VanCreditReviewMutationResult = Apollo.MutationResult<VanCreditReviewMutation>;
export type VanCreditReviewMutationOptions = Apollo.BaseMutationOptions<
	VanCreditReviewMutation,
	VanCreditReviewMutationVariables
>;
export const SimulateVanCreditDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'SimulateVanCredit' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateVanCreditInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'simulateVanCredit' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type SimulateVanCreditMutationFn = Apollo.MutationFunction<
	SimulateVanCreditMutation,
	SimulateVanCreditMutationVariables
>;

/**
 * __useSimulateVanCreditMutation__
 *
 * To run a mutation, you first call `useSimulateVanCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateVanCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateVanCreditMutation, { data, loading, error }] = useSimulateVanCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateVanCreditMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SimulateVanCreditMutation,
		SimulateVanCreditMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SimulateVanCreditMutation, SimulateVanCreditMutationVariables>(
		SimulateVanCreditDocument,
		options
	);
}
export type SimulateVanCreditMutationHookResult = ReturnType<typeof useSimulateVanCreditMutation>;
export type SimulateVanCreditMutationResult = Apollo.MutationResult<SimulateVanCreditMutation>;
export type SimulateVanCreditMutationOptions = Apollo.BaseMutationOptions<
	SimulateVanCreditMutation,
	SimulateVanCreditMutationVariables
>;
export const RejectVanCreditRequestDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RejectVanCreditRequest' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'RejectVanCreditRequestInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rejectVanCreditRequest' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RejectVanCreditRequestMutationFn = Apollo.MutationFunction<
	RejectVanCreditRequestMutation,
	RejectVanCreditRequestMutationVariables
>;

/**
 * __useRejectVanCreditRequestMutation__
 *
 * To run a mutation, you first call `useRejectVanCreditRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectVanCreditRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectVanCreditRequestMutation, { data, loading, error }] = useRejectVanCreditRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectVanCreditRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectVanCreditRequestMutation,
		RejectVanCreditRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectVanCreditRequestMutation,
		RejectVanCreditRequestMutationVariables
	>(RejectVanCreditRequestDocument, options);
}
export type RejectVanCreditRequestMutationHookResult = ReturnType<
	typeof useRejectVanCreditRequestMutation
>;
export type RejectVanCreditRequestMutationResult =
	Apollo.MutationResult<RejectVanCreditRequestMutation>;
export type RejectVanCreditRequestMutationOptions = Apollo.BaseMutationOptions<
	RejectVanCreditRequestMutation,
	RejectVanCreditRequestMutationVariables
>;
export const FillEvaluationMatrixDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'FillEvaluationMatrix' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'FillEvaluationMatrixInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'fillEvaluationMatrix' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type FillEvaluationMatrixMutationFn = Apollo.MutationFunction<
	FillEvaluationMatrixMutation,
	FillEvaluationMatrixMutationVariables
>;

/**
 * __useFillEvaluationMatrixMutation__
 *
 * To run a mutation, you first call `useFillEvaluationMatrixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillEvaluationMatrixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillEvaluationMatrixMutation, { data, loading, error }] = useFillEvaluationMatrixMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillEvaluationMatrixMutation(
	baseOptions?: Apollo.MutationHookOptions<
		FillEvaluationMatrixMutation,
		FillEvaluationMatrixMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<FillEvaluationMatrixMutation, FillEvaluationMatrixMutationVariables>(
		FillEvaluationMatrixDocument,
		options
	);
}
export type FillEvaluationMatrixMutationHookResult = ReturnType<
	typeof useFillEvaluationMatrixMutation
>;
export type FillEvaluationMatrixMutationResult =
	Apollo.MutationResult<FillEvaluationMatrixMutation>;
export type FillEvaluationMatrixMutationOptions = Apollo.BaseMutationOptions<
	FillEvaluationMatrixMutation,
	FillEvaluationMatrixMutationVariables
>;
export const PassVanRequestToCreditCommitteeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'PassVanRequestToCreditCommittee' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'PassVanRequestToCreditCommitteeInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'passVanRequestToCreditCommittee' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type PassVanRequestToCreditCommitteeMutationFn = Apollo.MutationFunction<
	PassVanRequestToCreditCommitteeMutation,
	PassVanRequestToCreditCommitteeMutationVariables
>;

/**
 * __usePassVanRequestToCreditCommitteeMutation__
 *
 * To run a mutation, you first call `usePassVanRequestToCreditCommitteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassVanRequestToCreditCommitteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passVanRequestToCreditCommitteeMutation, { data, loading, error }] = usePassVanRequestToCreditCommitteeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePassVanRequestToCreditCommitteeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PassVanRequestToCreditCommitteeMutation,
		PassVanRequestToCreditCommitteeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PassVanRequestToCreditCommitteeMutation,
		PassVanRequestToCreditCommitteeMutationVariables
	>(PassVanRequestToCreditCommitteeDocument, options);
}
export type PassVanRequestToCreditCommitteeMutationHookResult = ReturnType<
	typeof usePassVanRequestToCreditCommitteeMutation
>;
export type PassVanRequestToCreditCommitteeMutationResult =
	Apollo.MutationResult<PassVanRequestToCreditCommitteeMutation>;
export type PassVanRequestToCreditCommitteeMutationOptions = Apollo.BaseMutationOptions<
	PassVanRequestToCreditCommitteeMutation,
	PassVanRequestToCreditCommitteeMutationVariables
>;
export const ApproveRequestByCreditCommitteeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ApproveRequestByCreditCommittee' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'ApproveRequestByCreditCommitteeInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'approveRequestByCreditCommittee' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ApproveRequestByCreditCommitteeMutationFn = Apollo.MutationFunction<
	ApproveRequestByCreditCommitteeMutation,
	ApproveRequestByCreditCommitteeMutationVariables
>;

/**
 * __useApproveRequestByCreditCommitteeMutation__
 *
 * To run a mutation, you first call `useApproveRequestByCreditCommitteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRequestByCreditCommitteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRequestByCreditCommitteeMutation, { data, loading, error }] = useApproveRequestByCreditCommitteeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveRequestByCreditCommitteeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveRequestByCreditCommitteeMutation,
		ApproveRequestByCreditCommitteeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApproveRequestByCreditCommitteeMutation,
		ApproveRequestByCreditCommitteeMutationVariables
	>(ApproveRequestByCreditCommitteeDocument, options);
}
export type ApproveRequestByCreditCommitteeMutationHookResult = ReturnType<
	typeof useApproveRequestByCreditCommitteeMutation
>;
export type ApproveRequestByCreditCommitteeMutationResult =
	Apollo.MutationResult<ApproveRequestByCreditCommitteeMutation>;
export type ApproveRequestByCreditCommitteeMutationOptions = Apollo.BaseMutationOptions<
	ApproveRequestByCreditCommitteeMutation,
	ApproveRequestByCreditCommitteeMutationVariables
>;
export const RejectRequestByCreditCommitteeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RejectRequestByCreditCommittee' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'RejectRequestByCreditCommitteeInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rejectRequestByCreditCommittee' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RejectRequestByCreditCommitteeMutationFn = Apollo.MutationFunction<
	RejectRequestByCreditCommitteeMutation,
	RejectRequestByCreditCommitteeMutationVariables
>;

/**
 * __useRejectRequestByCreditCommitteeMutation__
 *
 * To run a mutation, you first call `useRejectRequestByCreditCommitteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestByCreditCommitteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestByCreditCommitteeMutation, { data, loading, error }] = useRejectRequestByCreditCommitteeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectRequestByCreditCommitteeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectRequestByCreditCommitteeMutation,
		RejectRequestByCreditCommitteeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectRequestByCreditCommitteeMutation,
		RejectRequestByCreditCommitteeMutationVariables
	>(RejectRequestByCreditCommitteeDocument, options);
}
export type RejectRequestByCreditCommitteeMutationHookResult = ReturnType<
	typeof useRejectRequestByCreditCommitteeMutation
>;
export type RejectRequestByCreditCommitteeMutationResult =
	Apollo.MutationResult<RejectRequestByCreditCommitteeMutation>;
export type RejectRequestByCreditCommitteeMutationOptions = Apollo.BaseMutationOptions<
	RejectRequestByCreditCommitteeMutation,
	RejectRequestByCreditCommitteeMutationVariables
>;
export const CreateVanCreditDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'CreateVanCredit' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVanCreditInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'createVanCredit' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type CreateVanCreditMutationFn = Apollo.MutationFunction<
	CreateVanCreditMutation,
	CreateVanCreditMutationVariables
>;

/**
 * __useCreateVanCreditMutation__
 *
 * To run a mutation, you first call `useCreateVanCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVanCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVanCreditMutation, { data, loading, error }] = useCreateVanCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVanCreditMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateVanCreditMutation,
		CreateVanCreditMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateVanCreditMutation, CreateVanCreditMutationVariables>(
		CreateVanCreditDocument,
		options
	);
}
export type CreateVanCreditMutationHookResult = ReturnType<typeof useCreateVanCreditMutation>;
export type CreateVanCreditMutationResult = Apollo.MutationResult<CreateVanCreditMutation>;
export type CreateVanCreditMutationOptions = Apollo.BaseMutationOptions<
	CreateVanCreditMutation,
	CreateVanCreditMutationVariables
>;
export const ModifyVanCreditDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ModifyVanCredit' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ModifyVanCreditInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'modifyVanCredit' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ModifyVanCreditMutationFn = Apollo.MutationFunction<
	ModifyVanCreditMutation,
	ModifyVanCreditMutationVariables
>;

/**
 * __useModifyVanCreditMutation__
 *
 * To run a mutation, you first call `useModifyVanCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyVanCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyVanCreditMutation, { data, loading, error }] = useModifyVanCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyVanCreditMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ModifyVanCreditMutation,
		ModifyVanCreditMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ModifyVanCreditMutation, ModifyVanCreditMutationVariables>(
		ModifyVanCreditDocument,
		options
	);
}
export type ModifyVanCreditMutationHookResult = ReturnType<typeof useModifyVanCreditMutation>;
export type ModifyVanCreditMutationResult = Apollo.MutationResult<ModifyVanCreditMutation>;
export type ModifyVanCreditMutationOptions = Apollo.BaseMutationOptions<
	ModifyVanCreditMutation,
	ModifyVanCreditMutationVariables
>;
export const SignContractOpenfinVanCreditDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'SignContractOpenfinVanCredit' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'SignContractOpenfinVanCreditInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'signContractOpenfinVanCredit' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type SignContractOpenfinVanCreditMutationFn = Apollo.MutationFunction<
	SignContractOpenfinVanCreditMutation,
	SignContractOpenfinVanCreditMutationVariables
>;

/**
 * __useSignContractOpenfinVanCreditMutation__
 *
 * To run a mutation, you first call `useSignContractOpenfinVanCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignContractOpenfinVanCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signContractOpenfinVanCreditMutation, { data, loading, error }] = useSignContractOpenfinVanCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignContractOpenfinVanCreditMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SignContractOpenfinVanCreditMutation,
		SignContractOpenfinVanCreditMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SignContractOpenfinVanCreditMutation,
		SignContractOpenfinVanCreditMutationVariables
	>(SignContractOpenfinVanCreditDocument, options);
}
export type SignContractOpenfinVanCreditMutationHookResult = ReturnType<
	typeof useSignContractOpenfinVanCreditMutation
>;
export type SignContractOpenfinVanCreditMutationResult =
	Apollo.MutationResult<SignContractOpenfinVanCreditMutation>;
export type SignContractOpenfinVanCreditMutationOptions = Apollo.BaseMutationOptions<
	SignContractOpenfinVanCreditMutation,
	SignContractOpenfinVanCreditMutationVariables
>;
export const DownloadContractOpenfinVanCreditDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'DownloadContractOpenfinVanCredit' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'DownloadContractOpenfinVanCreditInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'downloadContractOpenfinVanCredit' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'result' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'creditContract' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'promissoryNote' } }
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type DownloadContractOpenfinVanCreditMutationFn = Apollo.MutationFunction<
	DownloadContractOpenfinVanCreditMutation,
	DownloadContractOpenfinVanCreditMutationVariables
>;

/**
 * __useDownloadContractOpenfinVanCreditMutation__
 *
 * To run a mutation, you first call `useDownloadContractOpenfinVanCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadContractOpenfinVanCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadContractOpenfinVanCreditMutation, { data, loading, error }] = useDownloadContractOpenfinVanCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadContractOpenfinVanCreditMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DownloadContractOpenfinVanCreditMutation,
		DownloadContractOpenfinVanCreditMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DownloadContractOpenfinVanCreditMutation,
		DownloadContractOpenfinVanCreditMutationVariables
	>(DownloadContractOpenfinVanCreditDocument, options);
}
export type DownloadContractOpenfinVanCreditMutationHookResult = ReturnType<
	typeof useDownloadContractOpenfinVanCreditMutation
>;
export type DownloadContractOpenfinVanCreditMutationResult =
	Apollo.MutationResult<DownloadContractOpenfinVanCreditMutation>;
export type DownloadContractOpenfinVanCreditMutationOptions = Apollo.BaseMutationOptions<
	DownloadContractOpenfinVanCreditMutation,
	DownloadContractOpenfinVanCreditMutationVariables
>;
export const GetVanCreditRequestDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GetVanCreditRequest' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'node' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'InlineFragment',
									typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Request' } },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'requestStatus' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncome' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'personalInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'houseType' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'livesWithWhichFamilyMember' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'transportationMethod' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'childDependants' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'otherFamilyDependants' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'otherFamilyDependantsExplanation' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'partnerHasAJob' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'partnerActivity' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'activityOrBusinessInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'activityDetail' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'operatingTimeRange' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditDetails' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'vehiclesRequested' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'term' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'downPaymentPercentage' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'downPaymentAmount' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'expectedAdditionalIncome' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'amountRequested' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'monthlyIncomeInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'businessSales' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'salary' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'familyContributionsIncome' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'otherSourcesIncome' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'otherSourcesIncomeDetail' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'totalIncome' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'monthlyBusinessExpenses' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'rent' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'electricBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'internetBill' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'equipmentMaintenance' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'inputsPurchase' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'salaries' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'gas' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalBusinessExpenses' }
														}
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'monthlyHouseExpenses' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'rent' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'electricBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'internetBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'waterBill' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'groceries' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'tuitions' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'familyExpenses' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'totalHouseExpenses' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'valueOfAssets' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'homeValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'landValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'carsValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'equipmentValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'equipmentDetail' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'savings' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'totalValueOfAssets' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'otherCredits' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'currentTotalDebt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'monthlyPaymentToCredits' }
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'onboardingRegistryDeliberation' }
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditBureauReport' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstCreditDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'oldestDuePayment' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'totalCreditBalance' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalActiveCreditBalance' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalNumberOfCredits' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'totalActiveNumberOfCredits' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'creditBureauScore' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'callComments' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'expectedProfitForNewVehicles' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'dailyFareIncome' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'dailyGasExpenses' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'dailyDriverSalary' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'monthlyMaintenanceExpenses' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'monthlyNetProfit' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'monthlyVehicleRent' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'calculatedNetIncomeIndex' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'recoveryTimeInYears' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyI' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyIi' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'applicantComprehensiveOperativeEfficiency' }
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'businessComprehensiveOperativeEfficiency' }
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'vehicleValue' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'creditAreaOpinion' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'committeeDeliberation' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'committeeRequestedChanges' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'committeeRuling' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'simulation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'numberOfPeriods' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'daysPerPeriod' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'paymentCapacity' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'lastPaymentAmount' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'configuration' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'amountRequested' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'paymentCapacity' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'daysPerPeriod' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'maximumNumberOfPeriods' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'ordinaryInterestRate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'firstPaymentDate' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'sameDayPayment' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'percentageOfCreditToSettle' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'gpsAmount' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'insuranceAmount' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'basisPoints' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'tiieValue' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'tiieDate' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'highestAmountToApprove' }
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'minimumPaymentToSettleTheCreditTotal'
																		}
																	},
																	{
																		kind: 'Field',
																		name: {
																			kind: 'Name',
																			value: 'minimumPaymentToSettleTheCreditPercentage'
																		}
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'installments' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'paymentNumber' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'initialBalance' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'creditPayment' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'principalPayment' }
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'interestPayment' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'interestTax' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'totalPayment' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'outstandingBalance' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'gpsAmount' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'gpsTax' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'insuranceAmount' }
																	},
																	{ kind: 'Field', name: { kind: 'Name', value: 'insuranceTax' } }
																]
															}
														}
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'evaluationMatrix' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantPaymentExperienceI' }
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'applicantPaymentExperienceIi' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'recoveryTimeInYears' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyI' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'economicSolvencyIi' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'familyMemberPaymentExperienceIi' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'totalScore' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'openfinCuenta' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'openfinIdasociado' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'expectedDisbursementDate' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'creditId' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'creditAccountDetails' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'amountRequested' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'ordinaryInterestRate' }
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'numberOfPeriods' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'daysPerPeriod' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'sameDayPayment' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstPaymentDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'basisPoints' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'tiieValue' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'tiieDate' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'gpsAmount' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'insuranceAmount' } }
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useGetVanCreditRequestQuery__
 *
 * To run a query within a React component, call `useGetVanCreditRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVanCreditRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVanCreditRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVanCreditRequestQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetVanCreditRequestQuery,
		GetVanCreditRequestQueryVariables
	> &
		({ variables: GetVanCreditRequestQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetVanCreditRequestQuery, GetVanCreditRequestQueryVariables>(
		GetVanCreditRequestDocument,
		options
	);
}
export function useGetVanCreditRequestLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetVanCreditRequestQuery,
		GetVanCreditRequestQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetVanCreditRequestQuery, GetVanCreditRequestQueryVariables>(
		GetVanCreditRequestDocument,
		options
	);
}
export function useGetVanCreditRequestSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetVanCreditRequestQuery, GetVanCreditRequestQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetVanCreditRequestQuery, GetVanCreditRequestQueryVariables>(
		GetVanCreditRequestDocument,
		options
	);
}
export type GetVanCreditRequestQueryHookResult = ReturnType<typeof useGetVanCreditRequestQuery>;
export type GetVanCreditRequestLazyQueryHookResult = ReturnType<
	typeof useGetVanCreditRequestLazyQuery
>;
export type GetVanCreditRequestSuspenseQueryHookResult = ReturnType<
	typeof useGetVanCreditRequestSuspenseQuery
>;
export type GetVanCreditRequestQueryResult = Apollo.QueryResult<
	GetVanCreditRequestQuery,
	GetVanCreditRequestQueryVariables
>;
export function refetchGetVanCreditRequestQuery(variables: GetVanCreditRequestQueryVariables) {
	return { query: GetVanCreditRequestDocument, variables: variables };
}
export const VanCreditRequestsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'VanCreditRequests' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } },
					type: {
						kind: 'ListType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'RequestSort' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'RequestFilter' } }
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requests' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'before' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'last' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'requestStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'creditDetails' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'vehiclesRequested' }
																	}
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'expectedDisbursementDate' }
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'count' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
										}
									]
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useVanCreditRequestsQuery__
 *
 * To run a query within a React component, call `useVanCreditRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVanCreditRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVanCreditRequestsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sorts: // value for 'sorts'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVanCreditRequestsQuery(
	baseOptions?: Apollo.QueryHookOptions<VanCreditRequestsQuery, VanCreditRequestsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VanCreditRequestsQuery, VanCreditRequestsQueryVariables>(
		VanCreditRequestsDocument,
		options
	);
}
export function useVanCreditRequestsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VanCreditRequestsQuery, VanCreditRequestsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VanCreditRequestsQuery, VanCreditRequestsQueryVariables>(
		VanCreditRequestsDocument,
		options
	);
}
export function useVanCreditRequestsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<VanCreditRequestsQuery, VanCreditRequestsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VanCreditRequestsQuery, VanCreditRequestsQueryVariables>(
		VanCreditRequestsDocument,
		options
	);
}
export type VanCreditRequestsQueryHookResult = ReturnType<typeof useVanCreditRequestsQuery>;
export type VanCreditRequestsLazyQueryHookResult = ReturnType<typeof useVanCreditRequestsLazyQuery>;
export type VanCreditRequestsSuspenseQueryHookResult = ReturnType<
	typeof useVanCreditRequestsSuspenseQuery
>;
export type VanCreditRequestsQueryResult = Apollo.QueryResult<
	VanCreditRequestsQuery,
	VanCreditRequestsQueryVariables
>;
export function refetchVanCreditRequestsQuery(variables?: VanCreditRequestsQueryVariables) {
	return { query: VanCreditRequestsDocument, variables: variables };
}
export const TiieBanxicoDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'TiieBanxico' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'tiieBanxicoValue' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'value' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'date' } }
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useTiieBanxicoQuery__
 *
 * To run a query within a React component, call `useTiieBanxicoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTiieBanxicoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTiieBanxicoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTiieBanxicoQuery(
	baseOptions?: Apollo.QueryHookOptions<TiieBanxicoQuery, TiieBanxicoQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TiieBanxicoQuery, TiieBanxicoQueryVariables>(TiieBanxicoDocument, options);
}
export function useTiieBanxicoLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TiieBanxicoQuery, TiieBanxicoQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TiieBanxicoQuery, TiieBanxicoQueryVariables>(
		TiieBanxicoDocument,
		options
	);
}
export function useTiieBanxicoSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<TiieBanxicoQuery, TiieBanxicoQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TiieBanxicoQuery, TiieBanxicoQueryVariables>(
		TiieBanxicoDocument,
		options
	);
}
export type TiieBanxicoQueryHookResult = ReturnType<typeof useTiieBanxicoQuery>;
export type TiieBanxicoLazyQueryHookResult = ReturnType<typeof useTiieBanxicoLazyQuery>;
export type TiieBanxicoSuspenseQueryHookResult = ReturnType<typeof useTiieBanxicoSuspenseQuery>;
export type TiieBanxicoQueryResult = Apollo.QueryResult<
	TiieBanxicoQuery,
	TiieBanxicoQueryVariables
>;
export function refetchTiieBanxicoQuery(variables?: TiieBanxicoQueryVariables) {
	return { query: TiieBanxicoDocument, variables: variables };
}
export const CalculateFirstPaymentDateDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'CalculateFirstPaymentDate' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'expectedDisbursementDate' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'daysPerPeriod' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'calculateFirstPaymentDate' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'expectedDisbursementDate' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'expectedDisbursementDate' }
								}
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'daysPerPeriod' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'daysPerPeriod' } }
							}
						]
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useCalculateFirstPaymentDateQuery__
 *
 * To run a query within a React component, call `useCalculateFirstPaymentDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateFirstPaymentDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateFirstPaymentDateQuery({
 *   variables: {
 *      expectedDisbursementDate: // value for 'expectedDisbursementDate'
 *      daysPerPeriod: // value for 'daysPerPeriod'
 *   },
 * });
 */
export function useCalculateFirstPaymentDateQuery(
	baseOptions: Apollo.QueryHookOptions<
		CalculateFirstPaymentDateQuery,
		CalculateFirstPaymentDateQueryVariables
	> &
		({ variables: CalculateFirstPaymentDateQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalculateFirstPaymentDateQuery, CalculateFirstPaymentDateQueryVariables>(
		CalculateFirstPaymentDateDocument,
		options
	);
}
export function useCalculateFirstPaymentDateLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalculateFirstPaymentDateQuery,
		CalculateFirstPaymentDateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CalculateFirstPaymentDateQuery,
		CalculateFirstPaymentDateQueryVariables
	>(CalculateFirstPaymentDateDocument, options);
}
export function useCalculateFirstPaymentDateSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CalculateFirstPaymentDateQuery,
				CalculateFirstPaymentDateQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CalculateFirstPaymentDateQuery,
		CalculateFirstPaymentDateQueryVariables
	>(CalculateFirstPaymentDateDocument, options);
}
export type CalculateFirstPaymentDateQueryHookResult = ReturnType<
	typeof useCalculateFirstPaymentDateQuery
>;
export type CalculateFirstPaymentDateLazyQueryHookResult = ReturnType<
	typeof useCalculateFirstPaymentDateLazyQuery
>;
export type CalculateFirstPaymentDateSuspenseQueryHookResult = ReturnType<
	typeof useCalculateFirstPaymentDateSuspenseQuery
>;
export type CalculateFirstPaymentDateQueryResult = Apollo.QueryResult<
	CalculateFirstPaymentDateQuery,
	CalculateFirstPaymentDateQueryVariables
>;
export function refetchCalculateFirstPaymentDateQuery(
	variables: CalculateFirstPaymentDateQueryVariables
) {
	return { query: CalculateFirstPaymentDateDocument, variables: variables };
}
export const DownloadVanCreditDocumentsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'DownloadVanCreditDocuments' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'creditId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentFormat' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentFormat' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'downloadDocuments' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'clientId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'creditId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'creditId' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'documentFormat' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'documentFormat' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'Field', name: { kind: 'Name', value: 'pdfBase64' } }]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useDownloadVanCreditDocumentsQuery__
 *
 * To run a query within a React component, call `useDownloadVanCreditDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadVanCreditDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadVanCreditDocumentsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      creditId: // value for 'creditId'
 *      documentFormat: // value for 'documentFormat'
 *   },
 * });
 */
export function useDownloadVanCreditDocumentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		DownloadVanCreditDocumentsQuery,
		DownloadVanCreditDocumentsQueryVariables
	> &
		({ variables: DownloadVanCreditDocumentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DownloadVanCreditDocumentsQuery, DownloadVanCreditDocumentsQueryVariables>(
		DownloadVanCreditDocumentsDocument,
		options
	);
}
export function useDownloadVanCreditDocumentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		DownloadVanCreditDocumentsQuery,
		DownloadVanCreditDocumentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		DownloadVanCreditDocumentsQuery,
		DownloadVanCreditDocumentsQueryVariables
	>(DownloadVanCreditDocumentsDocument, options);
}
export function useDownloadVanCreditDocumentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				DownloadVanCreditDocumentsQuery,
				DownloadVanCreditDocumentsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		DownloadVanCreditDocumentsQuery,
		DownloadVanCreditDocumentsQueryVariables
	>(DownloadVanCreditDocumentsDocument, options);
}
export type DownloadVanCreditDocumentsQueryHookResult = ReturnType<
	typeof useDownloadVanCreditDocumentsQuery
>;
export type DownloadVanCreditDocumentsLazyQueryHookResult = ReturnType<
	typeof useDownloadVanCreditDocumentsLazyQuery
>;
export type DownloadVanCreditDocumentsSuspenseQueryHookResult = ReturnType<
	typeof useDownloadVanCreditDocumentsSuspenseQuery
>;
export type DownloadVanCreditDocumentsQueryResult = Apollo.QueryResult<
	DownloadVanCreditDocumentsQuery,
	DownloadVanCreditDocumentsQueryVariables
>;
export function refetchDownloadVanCreditDocumentsQuery(
	variables: DownloadVanCreditDocumentsQueryVariables
) {
	return { query: DownloadVanCreditDocumentsDocument, variables: variables };
}
